import { createContext, useContext, useState, useEffect } from "react";
import { useAuth } from "../auth/AuthContext";
import { api } from "../api/clientInstance";

const TeamContext = createContext();

const DEFAULT_READINESS = { ready: false, no_team: true, missing_tactics: 0, no_starter: false };

export function TeamProvider({ children }) {
  const { accessToken } = useAuth();
  const [team, setTeam]           = useState(null);
  const [loading, setLoading]     = useState(true);
  const [readiness, setReadiness] = useState(DEFAULT_READINESS);

  const refreshReadiness = async () => {
    try {
      const data = await api("/players/ready");
      if (data) setReadiness(data);
    } catch { /* silently ignore — readiness is cosmetic */ }
  };

  useEffect(() => {
    if (!accessToken) {
      // Clear team state when the user logs out so stale data is never
      // shown to the next user who logs in on the same browser session.
      setTeam(null);
      setReadiness(DEFAULT_READINESS);
      setLoading(false);
      return;
    }

    async function fetchTeam() {
      try {
        setLoading(true);
        const data = await api("/user/team");
        if (data) {
          setTeam({ id: data.id, name: data.name, localColor: data.local_color, awayColor: data.away_color });
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    }

    fetchTeam();
    refreshReadiness();
  }, [accessToken]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <TeamContext.Provider value={{ team, setTeam, loading, readiness, refreshReadiness }}>
      {children}
    </TeamContext.Provider>
  );
}

export function useTeam() {
  return useContext(TeamContext);
}